import {
  OVERVIEW_ACTIVE,
  OVERVIEW_INACTIVE,
  FOLDER_ACTIVE,
  FOLDER_INACTIVE,
  REQUEST_ACTIVE,
  REQUEST_INACTIVE,
  PAYMENT_ACTIVE,
  PAYMENT_INACTIVE,
  NOTIFICATION_ACTIVE,
  NOTIFICATION_INACTIVE,
  SETTING_ACTIVE,
  SETTING_INACTIVE,
} from "../../../../assets";

export const LawyerSidebarRoute = [
  {
    title: "Overview",
    activeIcon: OVERVIEW_ACTIVE,
    inactiveIcon: OVERVIEW_INACTIVE,
    path: "/lawyer/overview",
  },
  {
    title: "Case Folders",
    activeIcon: FOLDER_ACTIVE,
    inactiveIcon: FOLDER_INACTIVE,
    path: "/lawyer/case-folders",
  },
  {
    title: "Request",
    activeIcon: REQUEST_ACTIVE,
    inactiveIcon: REQUEST_INACTIVE,
    path: "/lawyer/request",
  },
  {
    title: "Payment history",
    activeIcon: PAYMENT_ACTIVE,
    inactiveIcon: PAYMENT_INACTIVE,
    path: "/lawyer/payment-history",
  },
  {
    title: "Notification",
    activeIcon: NOTIFICATION_ACTIVE,
    inactiveIcon: NOTIFICATION_INACTIVE,
    path: "/lawyer/notification",
  },
  {
    title: "Setting",
    activeIcon: SETTING_ACTIVE,
    inactiveIcon: SETTING_INACTIVE,
    path: "/lawyer/setting",
  },
];
